module.exports = __webpack_public_path__ + "assets/img/icon-4.adab9481.png";